import { useQuery } from "@tanstack/react-query";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import { useEntities } from "@/lib/queries";
import { QuoteCard } from "@/components/quotes/QuoteCard";
import { useQuoteActions } from "@/pages/QuotesPage";

export const EntityQuotes = ({ ent, canEdit, onNavigate }) => {
  const { data: quotes = [] } = useQuery({ queryKey: ["entity-quotes", ent.id], queryFn: () => api.get(`/entities/${ent.id}/quotes`).then((r) => r.data) });
  const { data: entities = [] } = useEntities(ent.universe_id);
  const actions = useQuoteActions(ent.universe_id);
  if (!quotes.length && !canEdit) return null;
  return (
    <section className="mt-8" data-testid="entity-quotes">
      <div className="mb-3 flex items-center justify-between">
        <div className="lf-label">Quotes{quotes.length ? ` · ${quotes.length}` : ""}</div>
        {canEdit && <button onClick={actions.add} className="flex items-center gap-1 text-xs text-[#F59E0B] hover:underline" data-testid="entity-quote-add"><Plus className="h-3.5 w-3.5" />Add quote</button>}
      </div>
      {quotes.length === 0 ? <p className="text-sm italic text-[#A8A090]">No quotes yet.</p> : (
        <div className="space-y-3">{quotes.map((q) => <QuoteCard key={q.id} q={q} onNavigate={onNavigate} canEdit={canEdit} highlight={ent.id} {...actions} />)}</div>
      )}
      {actions.dialogs(entities, ent.id)}
    </section>
  );
};
